export default __webpack_public_path__ + "static/5-118ec8b0accae9b288bb218cb9140b6d.jpeg";